import Constants from '../Constants.js';
const initialState = {
  // projectId : 
  //   status : 'loading',
  //   error : { },
  //   modules : [
  //      { module 0 }
  //   ],
  //  moduleStatus : {
  //    id : { status, error }
  //  }
  //     
};
function createProjectState(curr, name, status = null, error = null) {
  if (name == null) {
    if (curr == null) {
      return {
        modules: [],
        moduleStatus: {},
        status,
        error
      };
    }
    return {
      modules: [],
      moduleStatus: {},
      ...curr,
      status,
      error
    };
  }
  let rtn = null;
  if (curr == null) {
    rtn = {
      status: null,
      error: null,
      modules: [],
      moduleStatus: {}
    };
  } else {
    rtn = {
      ...curr,
      moduleStatus: {
        ...curr.moduleStatus
      }
    };
    if (status == null) {
      delete rtn.moduleStatus[name];
    } else {
      rtn.moduleStatus[name] = {
        status,
        error
      };
    }
  }
  return rtn;
}

// eslint-disable-next-line default-param-last
function modules(state = initialState, action) {
  switch (action.type) {
    case Constants.MODULE_STATUS:
      {
        const {
          projectId,
          name,
          status,
          error = null
        } = action;
        const nState = {
          ...state
        };
        nState[projectId] = createProjectState(state[projectId], name, status, error);
        return nState;
      }
    case Constants.MODULE_LIST:
      {
        const {
          projectId,
          items
        } = action;
        const nState = {
          ...state
        };
        nState[projectId] = createProjectState(state[projectId]);
        nState[projectId].modules = items;
        return nState;
      }
    case Constants.MODULE_ADD:
      {
        const {
          projectId,
          module
        } = action;
        const nState = {
          ...state
        };
        nState[projectId] = createProjectState(state[projectId]);
        nState[projectId].modules = [...nState[projectId].modules, module];
        return nState;
      }
    case Constants.MODULE_REMOVE:
      {
        const {
          projectId,
          moduleName
        } = action;
        const nState = {
          ...state
        };
        nState[projectId] = createProjectState(state[projectId], moduleName);
        // eslint-disable-next-line eqeqeq
        nState[projectId].modules = nState[projectId].modules.filter(m => m.name != moduleName);
        return nState;
      }
    case Constants.MODULE_UPDATE:
      {
        const {
          projectId,
          module
        } = action;
        const nState = {
          ...state
        };
        nState[projectId] = createProjectState(state[projectId], module.name);
        nState[projectId].modules = nState[projectId].modules.map(m => {
          // eslint-disable-next-line eqeqeq
          if (m.name != module.name) {
            return m;
          }
          return module;
        });
        return nState;
      }
    default:
      {
        return state;
      }
  }
}
function getStatus(state, projectId, name) {
  const prjId = projectId || process?.env?.projectId;
  if (state && state[prjId]) {
    if (name != null) {
      const rs = state[prjId].moduleStatus;
      return rs && rs[name] && rs[name].status ? rs[name].status : null;
    }
    return state[prjId].status;
  }
  return null;
}
function getError(state, projectId, name) {
  const prjId = projectId || process?.env?.projectId;
  if (state && state[prjId]) {
    if (name != null) {
      const rs = state[prjId].moduleStatus;
      return rs && rs[name] && rs[name].error ? rs[name].error : null;
    }
    return state[prjId].error;
  }
  return null;
}
function getModules(state, projectId) {
  const prjId = projectId || process?.env?.projectId;
  if (state && state[prjId] && state[prjId].modules) {
    return state[prjId].modules;
  }
  return [];
}
modules.getStatus = getStatus;
modules.getError = getError;
modules.getModules = getModules;
export default modules;